import { render, staticRenderFns } from "./HullCoatingIndicator.vue?vue&type=template&id=1a9c2ae6&scoped=true&"
import script from "./HullCoatingIndicator.vue?vue&type=script&lang=ts&"
export * from "./HullCoatingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./HullCoatingIndicator.vue?vue&type=style&index=0&id=1a9c2ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c2ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSkeletonLoader})
